/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveMapData } from './eve-map.data';
import { IEveMapProps } from './eve-map.props.autogenerated';

export interface IEveMapViewProps extends IEveMapProps<IEveMapData> {}

/**
 *
 * EveMap component
 * @extends {React.PureComponent<IEveMapProps<IEveMapData>>}
 */
class EveMap extends React.PureComponent<IEveMapProps<IEveMapData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default EveMap;
